
export default {
  assembleDetail: {
    GroupPrice: '拼团价',
    only: '人成团，仅差',
    missing: '人拼成',
    notpaid: '您还未支付，支付成功后即可开团',
    GroupLeader: '团长',
    Only: '仅剩',
    End: '结束',
    Process: '拼团流程',
    ActivityRules: '活动规则',
    LeaderStarts: '团长开团',
    InviteFriends: '邀请好友',
    BuyingSuccess: '拼团成功',
    Waitingfor: '等待发货',
    ViewMoreGroup: '查看更多拼团活动',
    PayNow: '立即支付',
    Goto: '前往',
    PersonalCenter: '"个人中心" - "我的订单"',
    orderdetails: '中查看订单详情',
    ViewMyOrders: '查看我的订单',
    InviteFriendsJoin: '邀请好友参团',
    JoinGroup: '加入拼团',
    NewGroup: '发起新的拼团',
    Others: '其他人正在拼',
    ViewMore: '查看更多',
    one: '1、用户参与拼团活动，开团成为团长，并邀请用户参团，在规定时间内参团人数达到限定人数，即组团成功，等待发货。',
    two: '2、如在开团后规定时间内，参团人数未达到限定人数，或成团前库存售罄，则组团失败，系统自动取消订单，并全额原路退款至支付账户。',
    three: '3、拼团购买仅支持在线支付，暂不支持货到付款。',
    four: '4、关于取消订单的说明: 如拼团订单未成功支付，若其参与的团已拼成功或失败，则该拼团订单自动取消；拼团订单支付成功后不支持取消订单；拼团失败时该团所有订单自动取消。',
    five: '5、对于部分超值热销的商品，会设定拼团限购数量，敬请留意提示，如存在违规行为、通过不正当手段参与优惠活动，FAFULI有权取消您的参与资格，相关优惠作废。',
    six: '6、在FAFULI个人中心——我的拼团，可以查看自己的拼团。',
    eight: '7、FAFULI可在法律允许范围内对本活动规则进行解释。',
    higher: '起',
    Quantity: '数量',
    Limitedpurchasequantity: '限购数量',
    Confirm: '确定',
    a: '哎呀，该活动刚好结束。可以查看其他火爆活动～',
    b: '哎呀，该活动中止了。可以查看其他火爆活动～',
    Exceeded: '超出限购数量',
    select: '请选择规格！',
    takenoff: '该商品已下架！',
    Only1spot: '【仅剩1个名额】我',
    yuan: '元拼了',
    foryou: '你的好友邀你一起拼团，就差你了'
  }
}
